import P from '../bundles/GuestSignUp/pages'
import { isPresent } from './utilities'
import store from './store'

const filterElement = (profileElements, element) => {
  let home_present = profileElements.some(profile => profile.kind === element);
  return home_present && profileElements.filter(function (profile) {return profile.kind == element})[0];
}

export const generateProfileElementObject = (defaultAnswer, element, answer, embeddedAnswer='') => {
  const profileElements = store.getState().profileElements
  const activeProfileElements = store.getState().user.guest.type.guest_profile_elements
  let home = filterElement(profileElements, element);
  let response;

  if (home && home.answers[answer] != undefined) {
    if (typeof home.answers[answer] === 'object' && embeddedAnswer != '') {
      response = (home.answers[answer][embeddedAnswer] === undefined) ? defaultAnswer : home.answers[answer][embeddedAnswer];
    } else {
      response = home.answers[answer];
    }
  } else {
    response = defaultAnswer;
  }
  return {
    val: response,
    validationKey: activeProfileElements.includes(answer) ? `profile_elements_${element}_${answer}${isPresent(embeddedAnswer) ? `_${embeddedAnswer}` : ''}` : '',
    profileElement: answer
  }
};

export const setProfileElementsFromState = (defaultAnswer, element, answer, embeddedAnswer='') => {
  const { profileElements } = store.getState()
  let home = filterElement(profileElements, element);
  let response;

  if (home && home.answers[answer] != undefined) {
    if (typeof home.answers[answer] === 'object' && embeddedAnswer != '') {
      response = (home.answers[answer][embeddedAnswer] === undefined) ? defaultAnswer : home.answers[answer][embeddedAnswer];
    } else {
      response = home.answers[answer];
    }
  } else {
    response = defaultAnswer;
  }
  return response;
};

export const buildProfileForm = () => {
  const profileElements = store.getState().profileElements
  const schema = store.getState().localProfileElements.schema
  let form = {};
  let key, keyType, defaultAnswer;

  Object.keys(schema).forEach(function(section) {
    form[section] = {};
    Object.keys(schema[section]).forEach(function(sectionItem) {
      keyType = schema[section][sectionItem];
      key = buildProfileKey(schema, section, sectionItem);
      defaultAnswer = (keyType == 'Array' ? [] : '');
      form[section][key] = setProfileElementsFromState(defaultAnswer, section, sectionItem);
    });
  });
  return form;
};

export const buildProfileKey = (schema, section, sectionItem) => {
  let keyType = schema[section][sectionItem];
  if(typeof keyType === 'object') keyType = 'Object';
  return String(sectionItem + '|' + keyType);
};

export const updateProfileField = (form, schema, section, sectionItem, value) => {
  let key = buildProfileKey(schema, section, sectionItem);
  form[section][key] = value;
  return form;
};

export const updateForm = (form, payload) => {
  const schema = store.getState().localProfileElements.schema
  let value;
  Object.keys(payload).forEach(function(section) {
    Object.keys(payload[section]).forEach(function(sectionItem) {
      value = payload[section][sectionItem];
      form = updateProfileField(form, schema, section, sectionItem, value);
    })
  })
  return form;
};
